import styles from './Checkbox.module.scss';
import { Text } from 'components';

export const CheckBoxOption = ({ optionText, isChecked, id, register, value }: any) => {
  return (
    <div className={styles.inputWrapper}>
      <input type="checkbox" id={id} value={value ? value : id} {...register} />
      <label htmlFor={id}>
        <Text type="body2" className={styles.labelText}>
          {optionText}
        </Text>
      </label>
    </div>
  );
};
